import React from 'react';
import '../HumanResources.css';

function Accountant() {
  return (
    <div className="hr-page">
      <h1>ACCOUNTANT</h1>

      {/* Overview Section */}
      <h2>Overview</h2>
      <p>
        The Accountant plays a crucial role in the financial health and compliance of Nesim. Their responsibilities include:
      </p>
      <ul>
        <li>
          Preparing financial statements such as balance sheets, income statements, and cash flow statements, which provide a clear overview of the company's financial performance. This is essential for monitoring financial health, making informed decisions, and reporting to stakeholders.
        </li>
        <li>
          Maintaining accurate financial records of transactions and entries, which ensures the integrity of financial data used for analysis and decision-making.
        </li>
        <li>
          Assisting in budget preparation and monitoring, which helps Nesim manage its finances effectively and track performance against targets.
        </li>
        <li>
          Preparing and filing tax returns, ensuring compliance with KRA regulations. This is critical for avoiding legal issues and maintaining good standing with regulatory bodies.
        </li>
        <li>
          Analyzing costs and identifying areas for improvement, contributing to increased efficiency and profitability.
        </li>
        <li>
          Providing financial insights and supporting decision-making across different departments.
        </li>
        <li>
          Reconciling bank statements and managing petty cash, ensuring accuracy and control over liquid assets.
        </li>
      </ul>

      {/* Qualifications Section */}
      <h2>Qualifications</h2>
      <ul>
        <li>
          <strong>Academic Qualifications:</strong>
          <ul>
            <li>Bachelor's Degree in Accounting, Finance, Economics, or a related field from a recognized university.</li>
            <li>Kenya Certificate of Secondary Education (KCSE): a good mean grade of C+ or higher with a C in Mathematics and English.</li>
            <li>International General Certificate of Secondary Education (IGCSE): a grade C in at least 6 papers, including English and Mathematics.</li>
          </ul>
        </li>
        <li>
          <strong>Professional Accountancy Qualifications:</strong>
          <ul>
            <li>Institute of Certified Public Accountants of Kenya (ICPAK): Certified Public Accountant (CPA-K).</li>
            <li>Association of Chartered Certified Accountants (ACCA): globally recognized qualification.</li>
          </ul>
        </li>
        <li>
          <strong>Other Relevant Qualifications:</strong>
          <ul>
            <li>Accounting Technicians Diploma (ATD) by KASNEB.</li>
            <li>Certificate in Accounting and Management Skills (CAMS) by KASNEB.</li>
            <li>Degrees with Accounting Specialization as a strong foundation.
            </li>
          </ul>
        </li>
        <li>
          <strong>Skills and Experience:</strong>
          <ul>
            <li>Analytical and problem-solving skills.</li>
            <li>Attention to detail.</li>
            <li>Proficiency in accounting software, ERP systems, and Excel.</li>
            <li>Strong communication and professional ethics.</li>
            <li>Relevant internships or prior accounting work experience.</li>
          </ul>
        </li>
      </ul>

      {/* Proposed Job Levels Section */}
      <h2>Proposed Job Levels for Accountant Role</h2>
      <p>
        This structure provides a potential progression within the Accountant role at Nesim, with increasing levels of responsibility and complexity.
      </p>

      {/* Level 1 */}
      <h3>Level 1: Junior Accountant / Accounting Assistant</h3>
      <ul>
        <li><strong>Focus:</strong> Primarily on the accurate and timely recording of financial transactions and basic reconciliation tasks.</li>
        <li>
          <strong>Key Responsibilities:</strong>
          <ul>
            <li>Posting daily financial transactions in accounting software or ledgers.</li>
            <li>Processing invoices and payments owed to suppliers and customers.</li>
            <li>Monitoring customer & supplier accounts; sending invoices and following up on outstanding payments.</li>
            <li>Inputting financial data into accounting systems, including receipts, payroll, and expenses.</li>
            <li>Preparing daily and weekly financial reports for management review.</li>
            <li>Reviewing and reconciling petty cash and other transactions.</li>
            <li>Recording inventory received.</li>
          </ul>
        </li>
      </ul>

      {/* Level 2 */}
      <h3>Level 2: Accountant</h3>
      <ul>
        <li><strong>Focus:</strong> Includes more complex tasks like preparing financial statements, assisting with budgeting, and ensuring compliance.</li>
        <li>
          <strong>Key Responsibilities:</strong>
          <ul>
            <li>Preparing financial statements, including balance sheets, income statements, and cash flow statements.</li>
            <li>Maintaining accurate records of financial transactions and entries.</li>
            <li>Assisting in the preparation of budgets and monitoring performance against those budgets.</li>
            <li>Comparing and reconciling bank statements with internal records monthly.</li>
            <li>Reviewing and categorizing expenses for proper budget management monthly.</li>
            <li>Ensuring compliance with KRA regulations monthly.</li>
            <li>Analyzing actual performance against the budget and identifying discrepancies monthly.</li>
          </ul>
        </li>
      </ul>

      {/* Level 3 */}
      <h3>Level 3: Senior Accountant</h3>
      <ul>
        <li><strong>Focus:</strong> More strategic responsibilities, including tax compliance, in-depth financial analysis, and forecasts.</li>
        <li>
          <strong>Key Responsibilities:</strong>
          <ul>
            <li>Preparing and filing tax returns, ensuring compliance with relevant tax laws and regulations.</li>
            <li>Analyzing costs and identifying areas for improvement in efficiency and profit margins.</li>
            <li>Conducting sales forecasts and analysis to provide financial insights.</li>
            <li>Working with other departments to support organizational goals and planning.</li>
            <li>Potentially overseeing the work of Junior Accountants/Assistants.</li>
            <li>Contributing to development of accounting policies and procedures.</li>
            <li>Leading audit preparations and liaising with auditors.</li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

export default Accountant;